// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6489b9bc","455":"8ff58d43","488":"632f7563"}[chunkId] + ".chunk.js";
};